export default "__VITE_ASSET__80a86fcd__"